import { ReactNode } from 'react'
import { ReactComponent as Logo } from '../../../../assets/Logo.svg'
import Layout from '../../Layout'
import styles from './AuthBase.module.css'

interface AuthBaseProps {
  children: ReactNode
  hasBackButton?: boolean
}

const AuthBase = ({ hasBackButton, children }: AuthBaseProps) => {
  return (
    <Layout hasBackButton={hasBackButton} containerStyle="inputContainer">
      <div className={styles.logoWrapper}>
        <Logo />
      </div>
      {children}
    </Layout>
  )
}

export default AuthBase
